/* CoCreate product page: variant pills, quantity, calculators and add to cart.
   Same math as the localhost prototype:
   - Square feet: width x length / 144 per piece, summed, rounded UP to whole sq ft (or one full sheet).
   - Board feet: thickness x width x length / 144 per board, summed, rounded to the NEAREST board foot.
   - Machine time: minutes x hourly rate / 60, to the cent. The item costs $0.01, so quantity = cents.
   Shopify quantities are whole numbers, which is why each one ends as a whole number. */
(function () {
  'use strict';

  function money(cents) { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }); }
  function num(n) { return n.toLocaleString('en-US'); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function timeLabel(m) { return (Math.floor(m / 60) ? Math.floor(m / 60) + ' h ' : '') + (m % 60) + ' min'; }
  var TRASH = '<svg viewBox="0 0 16 18" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M1 4h14M6 4V1.500h4V4M3 4l1 12.500h8L13 4M6.500 7.500v6M9.500 7.500v6"/></svg>';

  function init(root) {
    var data = JSON.parse(root.querySelector('[data-cc-json]').textContent);
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var variant = data.variants.filter(function (v) { return v.id === data.current; })[0] || data.variants[0];
    var qtyInput = q('[data-cc-qty-input]');
    var rows = [{ w: '', l: '' }];
    var properties = {};

    function unitWord(n) { return n === 1 ? data.units.one : data.units.many; }
    // Full-sheet size can differ by thickness (variant), falling back to the product's size.
    function sheetOf(v) { return (v && v.sheet) || data.sheet; }

    // ---------- variant ----------
    function setVariant(id) {
      var v = data.variants.filter(function (x) { return x.id === id; })[0];
      if (!v) return;
      variant = v;
      qa('[data-cc-variant]').forEach(function (b) {
        var on = Number(b.dataset.ccVariant) === id;
        if (b.classList.contains('cc-pill')) b.setAttribute('aria-pressed', on); else b.setAttribute('aria-current', on);
      });
      var img = q('[data-cc-main-img]');
      if (img && v.image) { img.src = v.image; img.removeAttribute('srcset'); }
      var price = q('[data-cc-price]');
      if (price) {
        var unit = price.querySelector('.cc-price__unit');
        price.innerHTML = v.price === 0 ? 'Free' : money(v.price) + (unit ? unit.outerHTML : '');
      }
      var sku = q('[data-cc-sku]');
      if (sku) sku.textContent = v.sku || '—';
      var fullLabel = q('[data-cc-full-label]');
      if (fullLabel) {
        var sh = sheetOf(v);
        fullLabel.textContent = sh.w + ' × ' + sh.l + ' in · ' + Math.floor(sh.w * sh.l / 144) + ' sq ft';
      }
      var url = new URL(location.href);
      url.searchParams.set('variant', id);
      history.replaceState(null, '', url);
      refresh();
    }
    qa('[data-cc-variant]').forEach(function (b) {
      b.addEventListener('click', function () { setVariant(Number(b.dataset.ccVariant)); });
    });

    // ---------- quantity ----------
    function setQty(n) {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, Math.min(99999, Math.round(n) || 1));
      lineTotal();
    }
    function lineTotal() {
      var el = q('[data-cc-line-total]');
      if (!el || !qtyInput) return;
      var n = Number(qtyInput.value) || 1;
      el.textContent = (data.unit === 'each' ? '' : num(n) + ' ' + unitWord(n) + ' · ') + money(n * variant.price);
    }
    qa('[data-cc-qty]').forEach(function (b) {
      b.addEventListener('click', function () { setQty((Number(qtyInput.value) || 1) + Number(b.dataset.ccQty)); });
    });
    if (qtyInput) qtyInput.addEventListener('input', lineTotal);

    // ---------- inventory ----------
    function inventory() {
      var el = q('[data-cc-inventory]');
      if (!el) return;
      if (!variant.available) { el.innerHTML = '<div class="cc-inventory is-out"><i></i>Sold out</div>'; return; }
      if (!variant.tracked || variant.qty <= 0 || data.unit === 'each' || data.unit === 'single') { el.innerHTML = ''; return; }
      el.innerHTML = '<div class="cc-inventory"><i></i>' + num(variant.qty) + ' ' + unitWord(variant.qty) + ' in stock</div>';
    }

    // ---------- pieces / boards ----------
    var rowBox = q('[data-cc-rows]');
    var noun = data.unit === 'bf' ? 'Board' : 'Piece';
    function readRows() {
      qa('.cc-board-row').forEach(function (row, i) {
        rows[i] = { w: row.querySelector('.cc-b-w').value, l: row.querySelector('.cc-b-l').value };
      });
    }
    function drawRows() {
      if (!rowBox) return;
      rowBox.innerHTML = rows.map(function (b, i) {
        var input = function (cls, label, val) {
          return '<label class="cc-calc__field"><input class="' + cls + '" type="number" inputmode="decimal" min="0" step="0.25" placeholder="0" value="' + esc(val) + '" aria-label="' + noun + ' ' + (i + 1) + ' ' + label + ' in inches"><span>in ' + label + '</span></label>';
        };
        return '<div class="cc-calc__row cc-board-row">' + input('cc-b-w', 'wide', b.w) + input('cc-b-l', 'long', b.l) +
          (rows.length > 1 ? '<button type="button" class="cc-icon-btn" data-cc-row-remove="' + i + '" aria-label="Remove ' + noun.toLowerCase() + ' ' + (i + 1) + '">' + TRASH + '</button>' : '') + '</div>';
      }).join('');
    }
    if (rowBox) {
      rowBox.addEventListener('input', refresh);
      rowBox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cc-row-remove]');
        if (!b) return;
        readRows();
        rows.splice(Number(b.dataset.ccRowRemove), 1);
        drawRows();
        refresh();
      });
      var add = q('[data-cc-row-add]');
      if (add) add.addEventListener('click', function () { readRows(); rows.push({ w: '', l: '' }); drawRows(); });
      drawRows();
    }
    var full = q('[data-cc-full]');
    if (full) full.addEventListener('change', refresh);

    function sheetSummary() {
      var box = q('[data-cc-summary]');
      var isFull = !!(full && full.checked);
      q('[data-cc-sheet]').classList.toggle('is-full', isFull);
      readRows();
      var total = 0, html = '', detail = [];
      if (isFull) {
        var sh = sheetOf(variant);
        total = sh.w * sh.l / 144;
        html = '<div><span>Full sheet</span><span>' + sh.w + ' × ' + sh.l + ' in = ' + total.toFixed(2) + ' sq ft</span></div>';
        detail.push('Full sheet ' + sh.w + ' × ' + sh.l + ' in');
      } else {
        rows.forEach(function (b, i) {
          var w = Math.max(0, Number(b.w) || 0), l = Math.max(0, Number(b.l) || 0);
          if (!w || !l) return;
          var area = w * l / 144;
          total += area;
          html += '<div><span>Piece ' + (i + 1) + '</span><span>' + w + ' × ' + l + ' in = ' + area.toFixed(2) + ' sq ft</span></div>';
          detail.push(w + ' × ' + l + ' in');
        });
      }
      if (!total) {
        box.innerHTML = '<div><span>Tick Full sheet, or enter the width and length of each piece in inches.</span></div>';
        properties = {};
        return;
      }
      var billed = Math.max(1, Math.ceil(total - 1e-9));
      box.innerHTML = html + (isFull ? '' : '<div><span>Measured</span><span>' + total.toFixed(2) + ' sq ft</span></div>') +
        '<div><span>Billed as</span><span>' + num(billed) + ' sq ft × ' + money(variant.price) + '</span></div>' +
        '<div class="cc-calc__total"><span>Total</span><b>' + money(billed * variant.price) + '</b></div>';
      properties = { 'Pieces': detail.join('; ') };
      setQty(billed);
    }
    function thickness() {
      var m = /^(\d+)\/4$/.exec(variant.title);
      return m ? Number(m[1]) / 4 : 1;
    }
    function lumberSummary() {
      var box = q('[data-cc-summary]');
      var t = thickness();
      readRows();
      var total = 0, html = '', detail = [];
      rows.forEach(function (b, i) {
        var w = Math.max(0, Number(b.w) || 0), l = Math.max(0, Number(b.l) || 0);
        if (!w || !l) return;
        var bf = t * w * l / 144;
        total += bf;
        html += '<div><span>Board ' + (i + 1) + '</span><span>' + t + ' × ' + w + ' × ' + l + ' in = ' + bf.toFixed(2) + ' BF</span></div>';
        detail.push(t + ' × ' + w + ' × ' + l + ' in');
      });
      if (!total) {
        box.innerHTML = '<div><span>Enter each board\'s width and length in inches. Thickness comes from the option above.</span></div>';
        properties = {};
        return;
      }
      var billed = Math.max(1, Math.round(total));
      box.innerHTML = html + '<div><span>Measured</span><span>' + total.toFixed(2) + ' board feet</span></div>' +
        '<div><span>Billed as</span><span>' + num(billed) + ' ' + unitWord(billed) + ' × ' + money(variant.price) + '</span></div>' +
        '<div class="cc-calc__total"><span>Total</span><b>' + money(billed * variant.price) + '</b></div>';
      properties = { 'Boards': detail.join('; ') };
      setQty(billed);
    }

    // ---------- machine time ----------
    var filSelect = q('[data-cc-filament]');
    if (filSelect) {
      filSelect.innerHTML = data.filaments.map(function (f, i) {
        return '<option value="' + i + '">' + esc(f.title) + ' · ' + money(f.price) + ' per gram</option>';
      }).join('');
      if (!data.filaments.length) filSelect.innerHTML = '<option value="">No filament listed yet</option>';
    }
    function machineLines() {
      var val = function (sel) { var el = q(sel); return el ? Math.max(0, Math.floor(Number(el.value)) || 0) : 0; };
      var minutes = val('[data-cc-hours]') * 60 + val('[data-cc-mins]');
      var out = { minutes: minutes, cents: Math.round(minutes * data.hourly * 100 / 60), grams: 0, filament: null };
      if (filSelect && data.filaments.length) {
        out.grams = val('[data-cc-grams]');
        out.filament = data.filaments[Number(filSelect.value) || 0];
      }
      return out;
    }
    function machineSummary() {
      var l = machineLines();
      var rate = money(Math.round(data.hourly * 100));
      var html = '<div><span>Time entered</span><span>' + timeLabel(l.minutes) + '</span></div>' +
        '<div><span>Machine time</span><span>' + timeLabel(l.minutes) + ' at ' + rate + '/hr = ' + money(l.cents) + '</span></div>';
      var filCost = 0;
      if (l.filament) {
        filCost = l.grams * l.filament.price;
        html += '<div><span>Filament</span><span>' + num(l.grams) + ' g ' + esc(l.filament.title) + ' × ' + money(l.filament.price) + ' = ' + money(filCost) + '</span></div>';
      }
      q('[data-cc-summary]').innerHTML = html + '<div class="cc-calc__total"><span>Total</span><b>' + money(l.cents + filCost) + '</b></div>';
      var empty = l.cents === 0 && l.grams === 0;
      qa('[data-cc-add], [data-cc-checkout]').forEach(function (b) { b.disabled = empty; });
    }
    if (data.unit === 'machine') {
      qa('[data-cc-hours], [data-cc-mins], [data-cc-grams], [data-cc-filament]').forEach(function (el) {
        el.addEventListener('input', machineSummary);
        el.addEventListener('change', machineSummary);
      });
    }

    // ---------- refresh ----------
    function refresh() {
      if (data.unit === 'sqft') sheetSummary();
      else if (data.unit === 'bf') lumberSummary();
      else if (data.unit === 'machine') machineSummary();
      lineTotal();
      inventory();
      if (data.unit !== 'machine') {
        qa('[data-cc-add], [data-cc-checkout]').forEach(function (b) { b.disabled = !variant.available; });
        var add = q('[data-cc-add]');
        if (add) add.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    // ---------- cart ----------
    function items() {
      if (data.unit === 'machine') {
        var l = machineLines();
        var list = [];
        if (l.cents > 0) list.push({ id: variant.id, quantity: l.cents, properties: { 'Time': timeLabel(l.minutes), 'Rate': money(Math.round(data.hourly * 100)) + ' per hour' } });
        if (l.filament && l.grams > 0) list.push({ id: l.filament.id, quantity: l.grams });
        return list;
      }
      var item = { id: variant.id, quantity: data.unit === 'single' ? 1 : Math.max(1, Number(qtyInput && qtyInput.value) || 1) };
      if (Object.keys(properties).length) item.properties = properties;
      return [item];
    }
    function showError(text) {
      var el = q('[data-cc-error]');
      el.textContent = text;
      el.hidden = !text;
    }
    function addToCart(then) {
      var list = items();
      if (!list.length) return;
      showError('');
      qa('[data-cc-add], [data-cc-checkout]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: list };
      if (drawer && then !== 'checkout') { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname; }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        qa('[data-cc-add], [data-cc-checkout]').forEach(function (b) { b.removeAttribute('aria-busy'); });
        if (res.status) { showError(res.description || res.message || 'That could not be added. Please try again.'); return; }
        if (then === 'checkout') { location.href = '/checkout'; return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.renderContents(res); }
        else { location.href = '/cart'; }
      }).catch(function () {
        qa('[data-cc-add], [data-cc-checkout]').forEach(function (b) { b.removeAttribute('aria-busy'); });
        showError('That could not be added. Please try again.');
      });
    }
    var addBtn = q('[data-cc-add]');
    var checkoutBtn = q('[data-cc-checkout]');
    if (addBtn) addBtn.addEventListener('click', function () { addToCart('drawer'); });
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { addToCart('checkout'); });

    refresh();
  }

  function start() { document.querySelectorAll('[data-cc-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Pay on your phone: a "Show QR code to pay" button next to Dawn's Check out button (side cart and
   cart page). The QR opens a checkout for exactly what is in this cart on the customer's own phone.
   "New sale" empties the cart for the next customer. Hidden on phones by cocreate.css. */
(function () {
  'use strict';

  var ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3"/></svg>';
  var CHECKOUTS = ['#CartDrawer-Checkout', '#checkout'];
  var me = document.querySelector('script[src*="cocreate.js"]');
  var QR_SRC = me ? me.src.replace(/cocreate\.js(\?.*)?$/, 'qrcode.min.js') : null;

  function money(cents) { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function loadQr(done) {
    if (window.QRCode) return done(true);
    if (!QR_SRC) return done(false);
    var s = document.createElement('script');
    s.src = QR_SRC;
    s.onload = function () { done(!!window.QRCode); };
    s.onerror = function () { done(false); };
    document.head.appendChild(s);
  }

  function addButtons() {
    CHECKOUTS.forEach(function (sel) {
      var co = document.querySelector(sel);
      if (!co) return;
      var btn = co.parentNode.querySelector('.cc-qr-btn');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button button--secondary cc-qr-btn';
        btn.innerHTML = ICON + '<span>Show QR code to pay</span>';
        co.insertAdjacentElement('afterend', btn);
      }
      btn.disabled = co.disabled;
    });
  }

  function itemLabel(i) {
    var label = i.product_title + (i.variant_title ? ' ' + i.variant_title : '');
    if (i.product_type === 'Machine Rate' && i.properties && i.properties.Time) return label + ' · ' + i.properties.Time;
    if (i.product_type === 'Machine Rate') return label;
    var unit = { 'Laser Material': ' sq ft', 'Sheet Goods': ' sq ft', 'Rough Lumber': ' bd ft', '3D Filament': ' g' }[i.product_type];
    return label + ' · ' + (unit ? i.quantity + unit : '× ' + i.quantity);
  }

  function close() {
    var o = document.getElementById('cc-qr-overlay');
    if (o) o.remove();
    document.body.classList.remove('cc-qr-open');
  }

  function open() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var url = 'https://' + location.host + '/cart/' + cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
        close();
        var o = document.createElement('div');
        o.id = 'cc-qr-overlay';
        o.className = 'cc-qr-overlay';
        o.innerHTML = '<div class="cc-qr-card" role="dialog" aria-modal="true" aria-labelledby="cc-qr-title">' +
          '<h2 id="cc-qr-title">Scan to pay</h2><p class="cc-qr-sub">Point your phone\'s camera at the code</p>' +
          '<div class="cc-qr-box"><div id="cc-qr-code"></div></div>' +
          '<p class="cc-qr-total">' + money(cart.total_price) + '</p>' +
          '<p class="cc-qr-items">' + cart.items.map(function (i) { return esc(itemLabel(i)); }).join(' &nbsp;·&nbsp; ') + '</p>' +
          '<p class="cc-qr-steps">1. Scan the code &nbsp; 2. Pay with Apple Pay, Google Pay or card &nbsp; 3. Your receipt is emailed to you</p>' +
          '<div class="cc-qr-actions"><button type="button" class="button button--secondary" data-cc-qr-close>Back to cart</button>' +
          '<button type="button" class="button" data-cc-qr-new>New sale</button></div></div>';
        document.body.appendChild(o);
        document.body.classList.add('cc-qr-open');
        loadQr(function (ok) {
          var box = document.getElementById('cc-qr-code');
          if (!box) return;
          if (ok) new window.QRCode(box, { text: url, width: 240, height: 240, colorDark: '#000033', colorLight: '#ffffff', correctLevel: window.QRCode.CorrectLevel.M });
          else box.innerHTML = '<p class="cc-qr-sub">The QR code could not load. Use Check out instead.</p>';
        });
      });
  }

  function newSale(btn) {
    btn.disabled = true;
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () { location.reload(); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.cc-qr-btn')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cc-qr-close]') || e.target.id === 'cc-qr-overlay') { close(); return; }
    var n = e.target.closest('[data-cc-qr-new]');
    if (n) newSale(n);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Dawn redraws the cart after every change, so keep putting the button back.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; addButtons(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addButtons); else addButtons();
})();
